import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';
import { EEntranceType } from '../../../packages/api-models/common/json_query';

export const selectInputType = createSelector(
  selectJsonQuery,
  jsonQuery => getTermsValue('input_type')(jsonQuery) as EEntranceType[] | null,
);
